import { currentSessionProvider } from "../api/fastapi";
import { useSignInWithOptroEnabled } from "./useSignInWithOptroEnabled";

/**
 * Whether the legacy AuditBoard "Integrations" admin page should be hidden.
 *
 * Once Optro sign-in is enabled AND the current session signed in via Optro, the
 * instance base_url and credential come from the OAuth token (aud-derived), so the
 * per-workspace integration config that page manages is obsolete. Gated on the
 * session provider too: WorkOS/password sessions in the same workspace still rely
 * on that config's base_url + API key, so they keep the page.
 */
export function useOptroIntegrationsHidden(): boolean {
  return useSignInWithOptroEnabled() && currentSessionProvider() === "optro";
}
